// Currency formatting helper - CHF
export const fmt = (amount) => {
  if (amount == null || isNaN(amount)) return "CHF 0.00";
  return `CHF ${Number(amount).toFixed(2)}`;
};
